import React from "react";

const StoreRequestsIndex = React.lazy(() => import("./index"));

export default [{ path: "/store/requests", component: StoreRequestsIndex, name: "StoreRequests" }];
